export default "__VITE_ASSET__FuqnV8VP__"